import React from 'react';
import { Select } from 'antd';
import styled from 'styled-components';
import languages from 'utils/languages';

const Wrapper = styled.div`
  text-align: center;
  padding: 0px !important;
`;

const SwitchLangButton: React.FC<{
  selectedLang: string;
  changeLang: (locale: string) => void;
}> = ({ selectedLang, changeLang }) => (
  <Wrapper>
    <Select
      defaultValue={selectedLang}
      onChange={(v) => changeLang(String(v))}
      variant="borderless"
      styles={{
        popup: {
          root: { textAlign: 'center' },
        },
      }}
      options={languages
        .filter((l) => l.active)
        .map((l) => ({
          label: l.flagIcon,
          value: l.prefix,
        }))}
      css={`
        .ant-select-suffix {
          color: rgba(0, 0, 0, 0.45);
          padding-bottom: 8px;
        }
        .ant-select-selection-item {
          display: flex;
          align-items: center;
        }
      `}
    />
  </Wrapper>
);

export default SwitchLangButton;
